// DrawerBusyMixin — add to a drawer-content form that auto-saves, to block the
// LayerHost close while a save is in flight (closing mid-save would race the
// request). The consuming component must expose a `drawerBusy` truthy value
// (data or computed) that is true while saving — e.g. `drawerBusy () { return
// this.savingStep }`.
//
// Unlike DrawerDirtyMixin, busy does NOT prompt — LayerHost simply vetoes the
// close and shows a brief "still saving…" notice until the save resolves.
//
// The no-op default in `inject` keeps the mixin inert outside a LayerHost.

export default {
  inject: {
    drawerDirtyRegistry: {
      default: function () {
        return {
          registerBusy: function () {},
          unregisterBusy: function () {},
          registerLeaveGuard: function () {},
          unregisterLeaveGuard: function () {}
        }
      }
    }
  },

  created () {
    this._busyChecker = function () { return !!this.drawerBusy }.bind(this)
    this.drawerDirtyRegistry.registerBusy(this._busyChecker)
  },

  beforeDestroy () {
    this.drawerDirtyRegistry.unregisterBusy(this._busyChecker)
  }
}
